import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=708a8e18&"
import script from "./RoleSetting.vue?vue&type=script&lang=js&"
export * from "./RoleSetting.vue?vue&type=script&lang=js&"
import style0 from "./RoleSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports